import { render, staticRenderFns } from "./BracketCardParticipant.vue?vue&type=template&id=e819f9ea&"
import script from "./BracketCardParticipant.vue?vue&type=script&lang=js&"
export * from "./BracketCardParticipant.vue?vue&type=script&lang=js&"
import style0 from "./BracketCardParticipant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports